/**
 * @Module: Auth Guard
 * @Status: Ready
 * @Summary: Route protection — redirects to /login when unauthenticated
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spinner, Center } from '@chakra-ui/react';
import { useAuth } from '../contexts/AuthContext';

const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <Center h="60vh"><Spinner size="lg" color="sage.500" /></Center>;
  if (!user) return <Navigate to="/login" />;
  return <>{children}</>;
};

export default RequireAuth;
